import { createSlice } from "@reduxjs/toolkit";
const selectedStoreSlice = createSlice({
  name: "items",
  initialState: {
    loading: false,
    items: [],
    error: "",
    item: "",
  },
  reducers: {
    setItemLoading(state) {
      state.loading = true;
    },
    setItemSuccess(state, action) {
      state.item = action.payload;
      state.loading = false;
    },
    setItemError(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    setItemsLoading(state) {
      state.loading = true;
    },
    setItemsSuccess(state, action) {
      state.items = action.payload;
      state.loading = false;
    },
    setItemsError(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    deleteListItemLoading: (state) => {
      state.loading = true;
    },
    deleteListItemSuccess: (state, action) => {
      state.loading = false;
      state.items = state.items.filter((item) => item.EAN13 !== action.payload);
    },
    deleteListItemFail: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  setItemLoading,
  setItemSuccess,
  setItemError,
  setItemsLoading,
  setItemsSuccess,
  setItemsError,
  deleteListItemLoading,
  deleteListItemSuccess,
  deleteListItemFail,
} = selectedStoreSlice.actions;
export default selectedStoreSlice.reducer;
